import React from "react";
import ListItem from "../ListItem";
import styles from "./index.module.scss";
import Space from "components/Space";
import { AskListItem, QueryType } from "../../../../../service/discuss";
import { Empty } from "antd";

interface AskListProps {
    data: AskListItem[];
    reload: () => void;
    query: QueryType;
}

export default function AskList({ data, reload, query }: AskListProps) {
    return (
        <div className={styles.root}>
            <Space className={styles.list} direction="vertical" size={10}>
                {data.map(item => (
                    <ListItem
                        query={query}
                        key={item.uuid}
                        data={item}
                        reload={reload}
                    />
                ))}
                {data.length === 0 && <Empty className={styles.emp} />}
            </Space>
        </div>
    );
}
